import { Grid } from "@mui/material";
import { FormSelectDynamic } from "../../../../components/hook-form/form-select.dynamic.component";
import { FormInput } from "../../../../components/hook-form/form-input.component";
import { FormDateField } from "../../../../components/hook-form/form-date.field.component";
import { equipmentApiKeyStore } from "../../../../api/masters/equipment-api-key-store";

export const HistoryForm = () => {
    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormSelectDynamic
                    name="equipmentServiceID"
                    label="Equipment Service"
                    getQueryKeyConfig={() => equipmentApiKeyStore.getEquipmentCalibrationServices()}
                    optionsValueKey="equipmentServiceID"
                    optionsLabelKeys={['equipmentServiceName']}
                />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormInput label="Description" name="description" multiline size={3} />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormDateField label="Serviced On" name="servicedOn" />
            </Grid>
        </Grid>
    );
}